<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备控制管理</li>
      </ul>
    </div> -->
    <!-- tab页 -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备列表
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备编号">
                <el-input placeholder="请输入设备编号" v-model="seefrom.deviceMark"></el-input>
              </el-form-item>
              <el-form-item label="服务类型">
                <el-input placeholder="请输入服务类型" v-model="seefrom.serviceType"></el-input>
              </el-form-item>
              <el-form-item label="指令名称">
                <el-input placeholder="请输入指令名称" v-model="seefrom.serviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select placeholder="请选择设备类型" v-model="seefrom.deviceType">
                  <el-option v-for="item in options" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <br />
              <el-form-item label="区域选择">
                <el-input placeholder="请选择区域" v-model="seefrom.curAreaName" @focus="changeAreaMode(1)"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable apiUrl="operation/command/list" :parent="self" :config="config" :other="other" ref="ins_history" :height="380">
          </easyTable>
        </div>

        <!-- 区域树 -->
        <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible=false" @regionTreeData="selRegionData"></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabName: 'jsgl',
      loading: true,
      form_jsgl: {},
      showTable: true,
      items: [],
      //区域树
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      //设备类型
      options: [],
      seefrom: {
        deviceMark: '',
        serviceType: '',
        serviceName: '',
        deviceType: '',
        curAreaName: '',
        regionId: '',
      },
      other: {},
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'deviceName',
          label: '操作设备',
        },
        {
          prop: 'area',
          label: '安装点',
        },
        {
          prop: 'serviceType',
          label: '服务类型',
        },
        {
          prop: 'serviceName',
          label: '指令名称',
        },
        {
          prop: 'value',
          label: '指令参数',
        },
        {
          prop: 'create_time',
          label: '创建时间',
        },
        {
          prop: 'statusName',
          label: '执行状态',
        },
      ]
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    mountPoint: () => import('public/mountPoint'),
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom
      this.$nextTick(this.$refs.ins_history.getData)
    },
    //重置
    reset() {
      ;(this.seefrom.serviceName = ''),
        (this.seefrom.serviceType = ''),
        (this.seefrom.deviceMark = ''),
        (this.seefrom.deviceType = ''),
        (this.seefrom.curAreaName = ''),
        (this.seefrom.regionId = '')
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true
      if (mode === 1) this.areaTreeMode = true
      if (mode === 2) this.areaTreeMode = false
      this.areaMode = mode
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode
      if (mode === 1) {
        this.seefrom.regionId = a.id
        this.seefrom.curAreaName = a.name
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, 'region', null)
          this.addEquipment.regionName = ''
          return
        }
        this.$set(this.addEquipment, 'region', a.id)
        this.addEquipment.regionName = a.name
      }
    },
  },
  created() {
    this.$axiosget('manager/devicetype/list').then((res) => {
      this.options = res.data.data
    })
  },
}
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
}
.easyTable {
  .el-table .cell {
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/instructions/instructionRecord.vue